import axios from "axios";
import {
  createContext,
  FC,
  useCallback,
  useContext,
  useState,
  useRef,
  useEffect,
} from "react";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";

interface PermissionDetail {
  isRead: boolean;
  isCreate: boolean;
  isUpdate: boolean;
  isDelete: boolean;
}
interface Permission {
  [key: string]: PermissionDetail;
}

interface Role {
  permission: Permission;
}

interface User {
  username: string;
  type: string;
  id: string;
  roleName?: string;
  role: Role | null;
  permissions?: Permission;
}

export const SelfPreOtpContext = createContext({
  user: {
    username: "",
    type: "",
    id: "",
    otpEnable: "",
    roleName: undefined,
    role: null,
    permissions: {},
  },
  isProcessing: false,
  onSyncSelf: () => {},
});

export const SelfPreOtpContextProvider: FC<any> = ({ children }) => {
  const navigation = useNavigate();
  const contextAuth = useContext(AuthContext);
  const [isProcessing, setIsProcessing] = useState(false);
  const [user, setUser] = useState({
    username: "",
    type: "",
    id: "",
    otpEnable: "",
    roleName: undefined,
    role: null,
    permissions: {} as Permission,
  });
  // const [isLoading, setIsLoading] = useState(true);

  const hasFetchedSelf = useRef(false);

  const onSyncSelf = useCallback(async () => {
    setIsProcessing(true);
    if (hasFetchedSelf.current) return; // หยุดการทำงานหากมีการ fetch ข้อมูลแล้ว
    try {
      const token = contextAuth.token;
      if (!token) {
        setIsProcessing(false);
        return;
      }

      const request = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/authorization/self-pre-otp`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const userData = {
        ...request.data.data,
        roleName: request.data.data.role.roleName,
        role: request.data.data.role,
        permissions: request.data.data.role.permissions,
      };
      // console.log("userData",userData)
      setUser(userData);
      hasFetchedSelf.current = true; // Mark as fetched
    } catch (error) {
      const response = (error as any).response;
      // if (response && response.status === 401) {
      //   contextAuth.onReset();
      //   localStorage.removeItem("NAGA_ADMIN:token");
      //   navigation("/");
      // }
      console.error("Unexpected error", error);
    } finally {
      setIsProcessing(false);
    }
  }, [contextAuth]);

  // useEffect(() => {
  //   onSyncSelf();
  // }, [onSyncSelf]);

  return (
    <SelfPreOtpContext.Provider value={{ user, isProcessing, onSyncSelf }}>
      {children}
    </SelfPreOtpContext.Provider>
  );
};
